import invariant from 'invariant';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import conformsTo from 'lodash/conformsTo';

export function checkStore(store) {
  const shape = {
    dispatch: isFunction,
    subscribe: isFunction,
    getState: isFunction,
    replaceReducer: isFunction,
    runSaga: isFunction,
    createReducer: isFunction,
    injectedReducers: isObject,
    injectedSagas: isObject,
  };
  invariant(
    conformsTo(store, shape),
    'checkStore: Expected a redux store that has been configured for use with redux injectors.',
  );
}
